export default {
  getDefaultState: () => {
    return {
      exports: [],
      export: {},
      exportationFlow: {},
      exportationFlows: [],
      exportationFlowsCurrentPage: 1,
      exportationFlowsLastPage: 1,
      exportHistory: undefined,
      exportsHistory: [],
      exportsHistoryCurrentPage: 1,
      exportsHistoryLastPage: 1,
      exportsHistoryFilters: {},
      isCallingExports: false
    }
  }
}
